var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperatur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.13,
    height: 62.05,
    viewBox: "0 0 49.13 62.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.56,12.93C11.02,12.93,0,23.95,0,37.49s11.02,24.56,24.56,24.56,24.56-11.02,24.56-24.56-11.02-24.56-24.56-24.56Zm0,46.54c-12.12,0-21.98-9.86-21.98-21.98S12.44,15.52,24.56,15.52s21.98,9.86,21.98,21.98-9.86,21.98-21.98,21.98Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.56,18.1c-10.69,0-19.39,8.7-19.39,19.39s8.7,19.39,19.39,19.39,19.39-8.7,19.39-19.39-8.7-19.39-19.39-19.39Zm0,36.2c-9.27,0-16.81-7.54-16.81-16.81s7.54-16.81,16.81-16.81,16.81,7.54,16.81,16.81-7.54,16.81-16.81,16.81Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.91,6.69c-1.21,1.21.62,3.04,1.83,1.83.98-.98,2.67-.98,3.65,0,1.2,1.2,3.04-.62,1.83-1.83-1.95-1.96-5.36-1.96-7.31,0Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.08,4.86c3.03-3.03,7.94-3.03,10.97,0,1.21,1.21,3.04-.62,1.83-1.83-4.04-4.04-10.58-4.04-14.63,0-1.21,1.21.62,3.04,1.83,1.83Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.68,32.32c0-.71-.58-1.29-1.29-1.29h-5.17c-1.71,0-1.71,2.59,0,2.59h3.88v2.59h-3.88c-1.71,0-1.71,2.59,0,2.59h3.88v2.59h-3.88c-1.71,0-1.71,2.59,0,2.59h5.17c.71,0,1.29-.58,1.29-1.29v-10.34Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.73,33.61c1.71,0,1.71-2.59,0-2.59h-5.17c-.71,0-1.29.58-1.29,1.29v5.17c0,.71.58,1.29,1.29,1.29h3.88v2.59h-3.88c-1.71,0-1.71,2.59,0,2.59h5.17c.71,0,1.29-.58,1.29-1.29v-5.17c0-.71-.58-1.29-1.29-1.29h-3.88v-2.59h3.88Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.9,32.32c1.71,0,1.71-2.59,0-2.59s-1.71,2.59,0,2.59Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.49,38.79h-.65c-.85,0-.86-1.29,0-1.29h.65c1.71,0,1.71-2.59,0-2.59h-.65c-1.78,0-3.23,1.45-3.23,3.23s1.45,3.23,3.23,3.23h.65c1.71,0,1.71-2.59,0-2.59Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.15,49.13h-5.17c-1.71,0-1.71,2.59,0,2.59h5.17c1.71,0,1.71-2.59,0-2.59Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatur);
export default __webpack_public_path__ + "static/media/temperatur.3ac06caec4ed982cb1df19ec88053e4e.svg";
export { ForwardRef as ReactComponent };